import { render, staticRenderFns } from "./institutes.vue?vue&type=template&id=5964a435&scoped=true&"
import script from "./institutes.vue?vue&type=script&lang=js&"
export * from "./institutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5964a435",
  null
  
)

export default component.exports